
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.093 5.777c-1.201 0-2.179.998-2.179 2.223 0 1.225.978 2.222 2.18 2.222 1.2 0 2.178-.997 2.178-2.222s-.977-2.223-2.179-2.223zm0 5.112C6.531 10.889 5.26 9.593 5.26 8c0-1.593 1.27-2.89 2.833-2.89 1.563 0 2.833 1.297 2.833 2.89 0 1.593-1.27 2.889-2.833 2.889zm-.78 4.444h1.56c.248-.736.437-1.634 1.378-2.033.978-.411 1.743.13 2.376.448l1.103-1.125c-.332-.698-.828-1.466-.438-2.428.371-.912 1.137-1.108 1.993-1.399V7.204c-.807-.28-1.616-.472-1.992-1.399-.374-.92.037-1.596.437-2.428l-1.103-1.124c-.73.364-1.452.838-2.38.445-.9-.38-1.083-1.156-1.374-2.031h-1.56c-.277.82-.46 1.645-1.372 2.03-.239.102-.47.151-.704.151-.551 0-1.006-.261-1.678-.595L2.456 3.377c.375.783.818 1.491.438 2.428C2.52 6.722 1.76 6.908.9 7.204v1.592c.802.279 1.614.47 1.993 1.399.38.935-.05 1.621-.438 2.428l1.103 1.125c.948-.483 1.54-.803 2.381-.446.901.381 1.082 1.159 1.373 2.031zM9.336 16H6.85c-.446-1.279-.514-1.809-1.16-2.082-.657-.28-1.131.088-2.266.635L1.666 12.76c.571-1.225.894-1.643.623-2.31-.269-.66-.779-.725-2.041-1.182V6.732C1.494 6.28 2.02 6.211 2.289 5.55c.27-.66-.046-1.075-.623-2.31l1.758-1.793c1.139.552 1.613.91 2.266.636.648-.275.707-.79 1.16-2.083h2.486c.446 1.279.515 1.81 1.16 2.082.654.277 1.117-.08 2.267-.635L14.52 3.24c-.575 1.232-.89 1.652-.623 2.31.269.662.78.725 2.042 1.183v2.537c-1.246.451-1.774.521-2.043 1.182-.263.65.03 1.04.624 2.309l-1.757 1.793c-1.13-.547-1.613-.914-2.26-.637-.646.273-.706.764-1.167 2.084z","fill":"#fff"}})])
          )
        }
      }
    